import HeaderLogo from "../../assets/Broward-Partnerships-for-kids-logo.png";
import { Link } from "react-router-dom";
import { useState } from "react";
import { history } from "../../_helpers/history";
import { useDispatch } from "react-redux";
import { authActions } from "../../_store";
import { Popup } from "../../components/common/ui/NotificationModal/Popup";
import { useEffect } from "react";
import { menuActions } from "../../_store/menu.slice";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import { useSelector } from "react-redux";
import CustomLoader from "../../components/common/ui/Loader";

function Header() {
  const dispatch = useDispatch();
  const ImageURL = process.env.REACT_APP_API_IMAGE_URL + "/";
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [menuData, setMenuData] = useState([]);
  const [openMenus, setOpenMenus] = useState([]);
  const loggedUserName = sessionStorage?.getItem("loggedUserName");
  const [userName, setUserName] = useState("");
  const { getProfileResponse } = useSelector((x) => x?.profile);
  const userRoleID = parseInt(sessionStorage?.getItem("userRoleID"));
  const [logoutLoading, setLogoutLoading] = useState(false);

  useEffect(() => {
    dispatch(menuActions.getMenuListHomePage())
      .then((result) => {
        if (result?.payload?.status === 1) {
          const rawMenuItems = result?.payload?.data?.menuItems;
          if (Array.isArray(rawMenuItems)) {
            setMenuData(result?.payload?.data?.menuItems); // or whatever you're using
          } else {
            console.error("menuItems is missing or invalid:", rawMenuItems);
          }
        }
      })
      .catch((err) => {
        showToastNotification("Failed to get menu list", "error");
      });
  }, [dispatch]);

  useEffect(() => {
    //get logged user name when profile img is not exist
    const firstName = loggedUserName?.split(" ")?.[0];
    const lastName = loggedUserName?.split(" ")?.[1];
    const firstLetterofFirstName = firstName && [...firstName][0];
    const lastLetterofFirstName = lastName && [...lastName][0];
    setUserName(
      firstLetterofFirstName?.toUpperCase() +
      lastLetterofFirstName?.toUpperCase()
    );
  }, [loggedUserName]);

  const navigateLoginPage = () => {
    history?.navigate("/login");
  };

  const handleMenuToggle = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const toggleSubMenu = (id) => {
    setOpenMenus(
      (prevOpenMenus) =>
        prevOpenMenus.includes(id)
          ? prevOpenMenus.filter((menuId) => menuId !== id) // Close submenu
          : [...prevOpenMenus, id] // Open submenu
    );
  };
  const navigateRegisterPage = () => {
    history?.navigate("/register");
  };

  const handleProfileClick = () => {
    history?.navigate("/myprofile");
  };

  const handleChangePassword = () => {
    history?.navigate("/changePassword");
  };

  const isUserLogged = JSON.parse(sessionStorage?.getItem("isLoggedIn"));

  const handleLogout = (e) => {
    Popup({
      title: "Message",
      text: `Are you sure want to logout?`,
      icon: "question",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      onConfirm: () => {
        setLogoutLoading(true);
        dispatch(authActions?.logout())
          .then((result) => {
            setLogoutLoading(false);
            if (result?.payload?.status === 1) {
              setIsMenuOpen(false);
              sessionStorage?.setItem("isLoggedIn", false);
              sessionStorage?.removeItem("userRoleID");
              history?.navigate("/login");
            } else {
              Popup({
                title: "Message",
                text: `${result?.error?.message}`,
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch((err) => {
            Popup({
              title: "Message",
              text: `Somthing went wrong`,
              icon: "error",
              confirmButtonText: "OK",
            });
            setLogoutLoading(false);
          });
      },
    });
  };

  if (logoutLoading) return <CustomLoader />;

  return (
    <>
      <header>
        <button
          className="logo cursor-pointer"
          style={{ background: "transparent", border: "none", outline: "none" }}
          onClick={() => {
            history?.navigate("/Home");
          }}
          tabIndex={0}
          aria-label="Broward Partnerships for Kids Home"
        >
          <img src={HeaderLogo} alt="Broward Partnerships for Kids Logo" className="logo" />
        </button>
        <div className="header-actions">
          {!isUserLogged && (
            <>
              <button
                className=" btn-login"
                onClick={() => {
                  navigateLoginPage();
                }}
              >
                Login
              </button>
              <button
                className=" btn-register"
                onClick={() => {
                  navigateRegisterPage();
                }}
              >
                Register
              </button>
            </>
          )}
          {isUserLogged && (
            <div className="dropdown profile-dropdown">
              <button
                className="btn profile-icon dropdown-toggle d-flex justify-content-center align-items-center gap-2"
                type="button"
                id="profileDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {getProfileResponse?.photo &&
                  getProfileResponse.photo.trim() !== "" ? (
                  <img
                    className="no-profile-img"
                    src={ImageURL + getProfileResponse.photo}
                    alt={loggedUserName || "User Profile Photo"}
                  />
                ) : (
                  <div className="no-profile-img">{userName}</div>
                )}

                <span className="logged-user-name" title={loggedUserName}>
                  {loggedUserName}
                </span>
              </button>
              <ul
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby="profileDropdown"
              >
                <li>
                  <button
                    className="dropdown-item"
                    onClick={handleProfileClick}
                  >
                    Profile
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item"
                    onClick={handleChangePassword}
                  >
                    Change Password
                  </button>
                </li>
                <li>
                  <button className="dropdown-item" onClick={handleLogout}>
                    logout
                  </button>
                </li>
              </ul>
            </div>
          )}
          <button
            className="hamburger-container"
            id="menuToggle"
            style={{ border: "none", outline: "none" }}
            tabIndex={0}
            aria-label="Toggle navigation menu"
            aria-expanded={isMenuOpen}
            onClick={() => {
              handleMenuToggle();
            }}
          >
            <div className="hamburger-icon"></div>
            <div className="hamburger-icon"></div>
            <div className="hamburger-icon half-point"></div>
            <div className="hamburger-text">MENU</div>
          </button>
        </div>
      </header>

      <div className={`side-menu ${isMenuOpen ? "open" : ""}`}>
        <button
          type="button"
          className="close-btn"
          id="menuClose"
          aria-label="Close menu"
          onClick={() => {
            setIsMenuOpen(false);
          }}
        >
          &times;
        </button>

        <ul className="pt-5">
          <li>
            <Link
              to="/Home"
              aria-label="Home"
              onClick={(e) => {
                e.preventDefault();
                history?.navigate("/Home");
                setIsMenuOpen(false);
              }}
            >
              Home
            </Link>
          </li>
          {(userRoleID === 3 || userRoleID === 2) && (
            <>
              {/* {userRoleID !== 2 && (
                <li>
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      history?.navigate("Admin/Committee");
                    }}
                  >
                    Our Mission
                  </Link>
                </li>
              )} */}
              <li>
                <Link
                  to="/Admin/dashboard"
                  aria-label="Admin Panel"
                  onClick={(e) => {
                    e.preventDefault();
                    history?.navigate("Admin/dashboard");
                  }}
                >
                  Admin Panel
                </Link>
              </li>

              <li>
                <Link
                  to="/Admin/dashboard"
                  aria-label="Reports"
                  onClick={(e) => {
                    e.preventDefault();
                    history?.navigate("Admin/dashboard");
                  }}
                >
                  Reports
                </Link>
              </li>
            </>
          )}
          {menuData.map((item) => {
            return (
              <li
                // className={item?.child?.length > 0 ? "dropdown" : ""}
                className={`dropdown ${openMenus.includes(item.id) ? "open" : "open"
                  }`}
                key={item.id}
              >
                <div className="menu-item ddd">
                  <Link
                    to={
                      item?.routeMethod === "internal"
                        ? `/Subpage${item?.url}`
                        : item?.url
                    }
                    {...(item.routeMethod === "internal"
                      ? { reloadDocument: true }
                      : {})}
                    target={
                      item?.routeMethod === "internal" ? "_self" : "_blank"
                    }
                    // target={item?.target}
                    onClick={() => {
                      setIsMenuOpen(false);
                    }}
                  >
                    {item.label}
                  </Link>
                  {item?.child?.length > 0 && (
                    <span
                      className="toggle-icon"
                      title="Expand Menu"
                      role="button"
                      tabIndex={0}
                      aria-label={
                        openMenus.includes(item.id)
                          ? "Collapse submenu"
                          : "Expand submenu"
                      }
                      aria-expanded={openMenus.includes(item.id)}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        toggleSubMenu(item.id);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.stopPropagation();
                          e.preventDefault();
                          toggleSubMenu(item.id);
                        }
                      }}
                    >
                      {openMenus.includes(item.id) ? "-" : "+"}
                    </span>
                  )}
                </div>
                <ul>
                  {item?.child?.length > 0 &&
                    openMenus.includes(item.id) &&
                    item?.child.map((child) => (
                      <li key={child.id}>
                        {child.routeMethod === "external" ? (
                          <Link
                            to={child.url}
                            target={child.target}
                            // target={
                            //   item?.routeMethod === "internal"
                            //     ? "_self"
                            //     : "_blank"
                            // }
                            onClick={() => {
                              setIsMenuOpen(false);
                            }}
                          >
                            {child.label}
                          </Link>
                        ) : (
                          <Link
                            to={`/Subpage${child.url}`} // 👈 no colon here
                            // target={child.target}
                            target={
                              item?.routeMethod === "internal"
                                ? "_self"
                                : "_blank"
                            }
                            {...(item.routeMethod === "internal"
                              ? { reloadDocument: true }
                              : {})}
                            onClick={() => {
                              setIsMenuOpen(false);
                            }}
                          >
                            {child.label}
                          </Link>
                        )}
                      </li>
                    ))}
                </ul>
              </li>
            );
          })}
          <li>
            <Link
              to="/BPKCommittees"
              aria-label="BPK Committees"
              onClick={(e) => {
                e.preventDefault();
                history?.navigate("/BPKCommittees");
                setIsMenuOpen(false);
              }}
            >
              BPK Committees
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
}

export default Header;
